import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";

export default function Completed() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([])
    let [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1); 
    const [numberOfPages, setNumberOfPages] = useState(0);

    const setpageLimit = (event) => {
        setLimit(event.target.value);
        setPageNumber(1);
    }

    const handlePageClick = (data) => {
        setPageNumber(data.selected + 1);
    };

    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.get(`${baseUrl}challange/completed_challange?page=${pageNumber}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(res.data.status)
                setNumberOfPages(res.data.totalPages)
            })
            .catch(err => console.log(err))
    }

    const dateFormat = (e) => {
        if (!e) return "N/A";
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        Allchallenge()
    }, [pageNumber, limit])

    if (challenge === undefined) {
        return null
    }

    return (
        <div className="completed-challenges-container p-2 p-md-4">
            <style>{`
                .completed-challenges-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
                .header-card { background: #fff; padding: 20px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 25px; display: flex; flex-direction: column; gap: 15px; }
                
                @media (min-width: 768px) {
                    .header-card { flex-direction: row; justify-content: space-between; align-items: center; padding: 25px; }
                }

                .table-card-main { background: #ffffff; border-radius: 25px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); border: none; }
                .table-banner-header { background: linear-gradient(45deg, #001b0b, #043618); color: #ffffff !important; padding: 18px 25px; font-weight: 700; font-size: 1.1rem; }
                
                /* Responsive Table Fix */
                .table-responsive-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }
                .custom-table-completed { width: 100%; border-collapse: collapse; min-width: 1100px; table-layout: auto; }
                
                .custom-table-completed th { background: #f8f9fa; color: #334155 !important; padding: 15px 12px; font-weight: 800; text-transform: uppercase; font-size: 0.75rem; border-bottom: 2px solid #edf2f7; text-align: center; white-space: nowrap; }
                .custom-table-completed td { padding: 15px 12px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.85rem; color: #000 !important; text-align: center; font-weight: 600; white-space: nowrap; }
                .custom-table-completed tbody tr:hover { background-color: #f0fff4; }

                .status-badge-success { background: #dcfce7; color: #15803d !important; padding: 6px 12px; border-radius: 10px; font-weight: 700; font-size: 0.7rem; text-transform: uppercase; border: 1px solid #bbf7d0; }
                .btn-view-action { background: #043618; color: white !important; border-radius: 8px; font-weight: 700; font-size: 0.8rem; padding: 8px 16px; border: none; transition: 0.3s; text-decoration: none; display: inline-block; }
                .btn-view-action:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(4, 54, 24, 0.3); }

                .pagination-wrapper .page-link { border-radius: 10px !important; margin: 0 4px; background: #fff; color: #043618; font-weight: 600; border: none; box-shadow: 0 2px 5px rgba(0,0,0,0.05); padding: 8px 16px; }
                .pagination-wrapper .page-item.active .page-link { background: #043618 !important; color: #fff !important; }
            `}</style>

            <div className="header-card">
                <div>
                    <h3 className="m-0" style={{fontWeight: 900, color: '#043618'}}>Completed <span style={{color: '#27ae60'}}>Battles</span></h3>
                    <p className="text-muted m-0" style={{fontSize: '0.85rem'}}>History of all successfully finished challenges</p>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <label className="m-0 mr-2 font-weight-bold" style={{fontSize: '0.85rem'}}>Display:</label>
                    <select className='form-control form-control-sm' style={{width: '90px', borderRadius: '8px', border: '2px solid #edf2f7', fontWeight: 'bold'}} onChange={setpageLimit} value={limit}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>

            <div className="table-card-main">
                <div className="table-banner-header">🏆 Battle Success History</div>
                <div className="table-responsive-wrapper">
                    <table className="custom-table-completed">
                        <thead>
                            <tr>
                                <th style={{width: '60px'}}>#</th>
                                <th>Challenge ID</th>
                                <th>Creator</th>
                                <th>Accepter</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Game Type</th>
                                <th>Winner</th>
                                <th>Completed On</th>
                                <th style={{width: '120px'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge && challenge.map((game, key) => (
                                <tr key={game._id}>
                                    <td style={{color: '#64748b'}}>#{(pageNumber - 1) * limit + (key + 1)}</td>
                                    <td style={{fontFamily: 'monospace', color: '#043618 !important'}}>{game._id}</td>
                                    <td style={{fontWeight: 700}}>{game.Created_by ? game.Created_by.Name : '---'}</td>
                                    <td style={{fontWeight: 700}}>{game.Accepetd_By ? game.Accepetd_By.Name : '---'}</td>
                                    <td style={{color: '#15803d !important', fontStyle: 'italic'}}>₹{game.Game_Ammount}</td>
                                    <td><span className="status-badge-success">{game.Status}</span></td>
                                    <td style={{textTransform: 'capitalize'}}>{game.Game_type}</td>
                                    <td style={{color: '#043618 !important', fontWeight: '800'}}>
                                        {game.Winner ? <span>⭐ {game.Winner.Name}</span> : '---'}
                                    </td>
                                    <td style={{fontSize: '0.75rem', color: '#64748b'}}>{dateFormat(game.createdAt)}</td>
                                    <td>
                                        <Link className="btn-view-action" to={`/view/${game._id}`}>
                                            View Details
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='pagination-wrapper mt-4'>
                <ReactPaginate
                    previousLabel={"←"}
                    nextLabel={"→"}
                    breakLabel={"..."}
                    pageCount={numberOfPages}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center flex-wrap"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link shadow-sm"}
                    activeClassName={"active"}
                    forcePage={pageNumber - 1}
                />
            </div>
        </div>
    )
}